module.exports = __webpack_public_path__ + "static/yang-2f7803df97877093a17d17a5a7264915.jpg";